import { createApp } from "vue";
import MaintenanceSchedule from "./maintenanceSchedule.vue";
import { createPinia } from "pinia";
createApp(MaintenanceSchedule)
    .use(createPinia())
    .mount("#maintenanceScheduleVueApp");
